import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * @graph-node {Page}
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business Styling Console分析セクションのレイアウトルート。Overview/Timing/Errorsの子ルートOutlet
 * @graph-connects none
 */
export const Route = createFileRoute('/styling')({
  component: StylingLayout,
});

/** @graph-connects none */
function StylingLayout() {
  return <Outlet />;
}
